import styled from "styled-components";
import { FormattedMessage } from "react-intl";

import Picture from "../Picture/Picture.js";

import * as type from '../../styles/type.js';

const Container = styled.figure`
  width: 100vw;
  height: 100%;
  padding: 0;
  margin: 0;
`;

const StyledPicture = styled(Picture)`
  width: 100vw;
  height: 100%;
  cursor: inherit;

  img {
    width: 100vw;
    height: 100%;
    object-fit: contain;
  }
`;

const CaptionWrapper = styled.div`
  ${type.mediaCaption}
  position: absolute;
  top: 0;
  right: 0;
  padding: 15px 3rem 0 15px;
  max-width: 35em;
`;

const Caption = styled.figcaption`
  background: #000;
  color: #fff;
  border-radius: 1em;
  padding: 0.4em 0.8em 0.3em 0.8em;
`;

const LightboxImage = ({ image, altText, caption, credit }) => {
  const sizes = image[0].ratio < 1 ? `${Math.round(image[0].ratio * 100)}w, (orientation: portrait) 100w` : '100w';
	return (
		<Container className="swiper-slide">
      <StyledPicture
        {...image[0]}
        alt={altText || caption}
        sizes={sizes}
        backgroundColour="transparent"
      />

      {caption && credit ?
        <CaptionWrapper>
          <Caption>
            {caption} (<FormattedMessage id="credit" />: {credit})
          </Caption>
        </CaptionWrapper>
      : caption ?
        <CaptionWrapper>
          <Caption>{caption}</Caption>
        </CaptionWrapper>
      : credit ?
        <CaptionWrapper>
          <Caption>
            <FormattedMessage id="credit" />: {credit}
          </Caption>
        </CaptionWrapper>
      : null}
		</Container>
	);
};

export default LightboxImage;
